<template>
<transition name="modal">
    <div class="modal-wrapper">
      <b-card class="modal-container-modifier">   
  <div>
    <div>
      <NotificationMessage v-if="showNotification" :message="toastMessage" :type="toastType" :duration="8000"/>
    </div>
    <form @submit.prevent="emitModifierRequete" id="validModif">
        <b-form-group v-if="!lectureSeule" class="labelTitre" id="input-group-1" label="Titre:" label-for="input-1">
          <Field name="titre" type="text" v-model="titre" placeholder="renseigner le titre de la requête" class="form-control" />
          <ErrorMessage name="titre" class="text-danger" />
        </b-form-group>

        <b-form-group class="labelTitre" id="input-group-2" label="Description:" label-for="textarea-large">
          <Field name="description" as="textarea" v-model="description" class="form-control" />
          <ErrorMessage name="description" class="text-danger" />
        </b-form-group>

      <b-row>
        <b-col md="6">
          <b-form-group class = "labelTitre" id="input-group-3" label="Schéma:" label-for="input-3">
            <b-form-select id="input-3" class="textForm" v-model="schema.idSchema" :disabled="lectureSeule" >
              <option v-for="s in schemas" v-bind:value="s.idSchema" v-bind:key="s.idSchema">{{s.nom}}</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group class = "labelTitre" id="input-group-4" label="Type:" label-for="input-4">
            <b-form-select id="input-4" class="textForm" v-model="type" :options="optionType" :disabled="lectureSeule"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

        <b-form-group class="labelTitre" id="input-group-5" label="Définition sql (vos paramètres doivent être précédés et suivis des caractères '!!')"
          label-for="textarea-large">
          <Field name="sql" as="textarea" v-model="sql" class="form-control" />
          <ErrorMessage name="sql" class="text-danger" />
        </b-form-group>

      <b-row>
        <b-col md="7">
          <ParametreList v-if="parametres.length!=0"
          :lectureSeule="lectureSeule"
          :parametres="parametres"           
          class="center">
          </ParametreList>    
        </b-col>
      </b-row>
      <b-button pill @click="showModal = true" class="test my-2 my-sm-0">Tester la requete</b-button>

      <b-modal id="modal-8" v-model="showModal" centered title="Tester la requête" hide-footer>
        <ModalTesterRequete :idRequete ="idRequetes"
                            :parametres="parametres"
                            :sql="sql"
                            @close="showModal = false"
                            @notification="handleNotification">
        </ModalTesterRequete>
      </b-modal>

      <b-form-group class="labelTitre" id="input-group-7" label="Champ(s) anomalique(s)" label-for="input-7">
        <b-form-input id="input-7"  class="textForm" v-model="champAnomalique" type="text" :readonly="lectureSeule"></b-form-input>
      </b-form-group>

      <b-form-group class="labelTitre" id="input-group-8" label="Mots clés" label-for="input-8">
        <b-form-input id="input-8" class="textForm" v-model="keywords" type="text" :readonly="lectureSeule"></b-form-input>
      </b-form-group>

      <div class="separation mb-4 mt-4"></div>
      <div class="rapport mb-4">INFORMATIONS AFFICHEES SUR LE RAPPORT</div>

      <b-row>
        <b-col md="6">
          <b-form-group class = "labelTitre" id="input-group-9" label="Niveau de gravité" label-for="input-9">
            <b-form-select id="input-9" class="textForm" v-model="gravite" :options="optionGravite" :disabled="lectureSeule"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group class="labelTitre" id="input-group-10" label="Message d'erreur" label-for="input-10">
        <b-form-input id="input-10" class="textForm" v-model="message" type="text" :readonly="lectureSeule"></b-form-input>
      </b-form-group>

      <b-form-group class="labelTitre" id="input-group-11" label="Tables" label-for="input-11">
        <b-form-input id="input-11" class="textForm" v-model="tables" type="text" :readonly="lectureSeule"></b-form-input>
      </b-form-group>


        <b-button pill type="submit" class="nav-link3 m-2">Valider</b-button>
        <b-button pill @click="$emit('close')" class="nav-link2 m-2">Annuler</b-button>
        </form>
  </div>
      </b-card>
    </div>
</transition>
</template>

<script>


import ParametreList from "@/components/Requete/ParametreList.vue"
import { Field, ErrorMessage } from 'vee-validate';
import ModalTesterRequete from '@/components/Requete/ModalTesterRequete.vue'
import NotificationMessage from "@/components/Notification.vue";
import {useModifRequete} from "@/composition/Requetes/modifRequete";


export default {
  name:'ModifRequete',

  components:{
    NotificationMessage,
    ParametreList,
    Field,
    ErrorMessage,
    ModalTesterRequete,
  },

  props:{
    idRequetes:{
      type:Number
    },
    lectureSeule:{
      type:Boolean,
      default:true
    }
  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props, { emit }) {
    return useModifRequete(props, {emit})
  }
}

</script>

<style>

.card-body{
  padding: 1.25em !important;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-container-modifier {
  background-color: #c0c0c0;
  width: 80%;
  margin: 0px auto;
  padding: 5px 10px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>